'use client';

import { GameCard } from '../components/GameCard';
import { MuteToggle } from '../components/MuteToggle';

/** Tic Tac Toe icon - grid with X and O */
const TicTacToeIcon = () => {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <line x1="35" y1="10" x2="35" y2="90" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <line x1="65" y1="10" x2="65" y2="90" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <line x1="10" y1="35" x2="90" y2="35" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <line x1="10" y1="65" x2="90" y2="65" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <line x1="15" y1="15" x2="30" y2="30" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="15" x2="15" y2="30" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <circle cx="77" cy="50" r="10" fill="none" stroke="white" strokeWidth="4" />
      <line x1="45" y1="72" x2="55" y2="82" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <line x1="55" y1="72" x2="45" y2="82" stroke="white" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
};

/** Flappy Bird icon - cute bird */
const FlappyBirdIcon = () => {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <ellipse cx="50" cy="55" rx="30" ry="25" fill="#FFE66D" />
      <ellipse cx="40" cy="60" rx="15" ry="10" fill="#FFA500" />
      <circle cx="60" cy="48" r="10" fill="white" />
      <circle cx="63" cy="48" r="6" fill="black" />
      <circle cx="65" cy="46" r="2" fill="white" />
      <polygon points="70,55 90,58 70,62" fill="#FF6B6B" />
      <polygon points="20,50 10,40 10,70 20,60" fill="#FFA500" />
    </svg>
  );
};

/** Space Invaders icon - cute alien */
const SpaceInvadersIcon = () => {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <rect x="25" y="30" width="50" height="40" rx="5" fill="white" />
      <circle cx="38" cy="45" r="8" fill="#1F2937" />
      <circle cx="62" cy="45" r="8" fill="#1F2937" />
      <circle cx="40" cy="43" r="3" fill="white" />
      <circle cx="64" cy="43" r="3" fill="white" />
      <line x1="35" y1="30" x2="30" y2="15" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <line x1="65" y1="30" x2="70" y2="15" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <circle cx="30" cy="15" r="5" fill="#FF6B6B" />
      <circle cx="70" cy="15" r="5" fill="#FF6B6B" />
      <rect x="40" y="55" width="20" height="8" rx="2" fill="#1F2937" />
      <rect x="30" y="70" width="8" height="15" rx="2" fill="white" />
      <rect x="62" y="70" width="8" height="15" rx="2" fill="white" />
    </svg>
  );
};

/** Bubble Pop icon - colorful bubbles */
const BubblePopIcon = () => {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <circle cx="35" cy="35" r="20" fill="#FF6B6B" opacity="0.9" />
      <circle cx="65" cy="45" r="25" fill="#4ECDC4" opacity="0.9" />
      <circle cx="40" cy="70" r="18" fill="#FFE66D" opacity="0.9" />
      <circle cx="70" cy="75" r="15" fill="#A78BFA" opacity="0.9" />
      <circle cx="28" cy="28" r="6" fill="white" opacity="0.6" />
      <circle cx="58" cy="38" r="8" fill="white" opacity="0.6" />
      <circle cx="33" cy="63" r="5" fill="white" opacity="0.6" />
    </svg>
  );
};

/** Animal Memory icon - two cards with paw prints */
const AnimalMemoryIcon = () => {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <rect x="10" y="20" width="35" height="45" rx="4" fill="white" />
      <rect x="55" y="35" width="35" height="45" rx="4" fill="white" />
      <circle cx="27" cy="42" r="4" fill="#1F2937" />
      <circle cx="20" cy="50" r="3" fill="#1F2937" />
      <circle cx="34" cy="50" r="3" fill="#1F2937" />
      <circle cx="27" cy="56" r="5" fill="#1F2937" />
      <text x="72" y="62" fontSize="24" textAnchor="middle" fill="#1F2937">
        ?
      </text>
    </svg>
  );
};

/** Farm Sounds icon - cow with music notes */
const FarmSoundsIcon = () => {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <ellipse cx="50" cy="55" rx="28" ry="22" fill="white" />
      <circle cx="38" cy="50" r="5" fill="#1F2937" />
      <circle cx="62" cy="50" r="5" fill="#1F2937" />
      <ellipse cx="50" cy="65" rx="12" ry="8" fill="#F472B6" />
      <circle cx="45" cy="65" r="2" fill="#1F2937" />
      <circle cx="55" cy="65" r="2" fill="#1F2937" />
      <ellipse cx="30" cy="35" rx="8" ry="12" fill="white" />
      <ellipse cx="70" cy="35" rx="8" ry="12" fill="white" />
      <text x="82" y="30" fontSize="16" fill="white">
        ♪
      </text>
      <text x="75" y="45" fontSize="12" fill="white">
        ♫
      </text>
    </svg>
  );
};

/** Fruit Catch icon - basket with fruit */
const FruitCatchIcon = () => {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <text x="30" y="30" fontSize="20">
        🍎
      </text>
      <text x="55" y="25" fontSize="18">
        🍌
      </text>
      <text x="45" y="45" fontSize="16">
        🍊
      </text>
      <path d="M25 55 L35 85 L65 85 L75 55 Z" fill="#8B4513" stroke="#5D2E0C" strokeWidth="2" />
      <ellipse cx="50" cy="55" rx="28" ry="8" fill="#A0522D" stroke="#5D2E0C" strokeWidth="2" />
    </svg>
  );
};

/** Shape Sorter icon - shapes */
const ShapeSorterIcon = () => {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <circle cx="30" cy="35" r="18" fill="#FF6B6B" stroke="white" strokeWidth="2" />
      <rect x="55" y="20" width="30" height="30" rx="3" fill="#4ECDC4" stroke="white" strokeWidth="2" />
      <polygon points="50,60 30,90 70,90" fill="#FFE66D" stroke="white" strokeWidth="2" />
    </svg>
  );
};

/** Maze Runner icon - bunny and maze */
const MazeRunnerIcon = () => {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <rect x="10" y="10" width="80" height="80" fill="none" stroke="white" strokeWidth="3" rx="4" />
      <line x1="10" y1="35" x2="50" y2="35" stroke="white" strokeWidth="3" />
      <line x1="40" y1="35" x2="40" y2="65" stroke="white" strokeWidth="3" />
      <line x1="40" y1="65" x2="90" y2="65" stroke="white" strokeWidth="3" />
      <line x1="65" y1="10" x2="65" y2="45" stroke="white" strokeWidth="3" />
      <text x="22" y="28" fontSize="18">
        🐰
      </text>
      <text x="72" y="88" fontSize="18">
        🥕
      </text>
    </svg>
  );
};

/** Coloring Book icon - paintbrush and palette */
const ColoringBookIcon = () => {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <ellipse cx="50" cy="60" rx="35" ry="25" fill="white" />
      <circle cx="30" cy="55" r="8" fill="#FF6B6B" />
      <circle cx="50" cy="50" r="8" fill="#4ECDC4" />
      <circle cx="70" cy="55" r="8" fill="#FFE66D" />
      <circle cx="40" cy="70" r="8" fill="#A78BFA" />
      <circle cx="60" cy="70" r="8" fill="#10B981" />
      <rect x="70" y="10" width="8" height="40" rx="2" fill="#8B4513" transform="rotate(30 74 30)" />
      <polygon points="82,8 90,20 78,22" fill="#1F2937" transform="rotate(30 84 15)" />
    </svg>
  );
};

/**
 * Landing page with game selection cards.
 */
const Home = () => {
  return (
    <main className="min-h-[100dvh] flex flex-col items-center justify-center p-4 sm:p-6 bg-[var(--color-bg-dark)] relative">
      {/* Floating shapes background */}
      <div className="floating-shapes" aria-hidden="true" />

      {/* Mute toggle */}
      <div className="fixed top-4 right-4 z-50">
        <MuteToggle />
      </div>

      {/* Header */}
      <div className="text-center mb-6 sm:mb-8 animate-bounce-in relative z-10">
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold animated-gradient-text">KidGameLand</h1>
        <p className="text-base sm:text-xl text-gray-300 mt-2">Tap a game to play!</p>
      </div>

      {/* Game cards grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4 max-w-5xl w-full relative z-10">
        <GameCard
          title="Tic Tac Toe"
          href="/games/tic-tac-toe"
          icon={<TicTacToeIcon />}
          color="bg-[var(--color-blue)]"
          delay={50}
        />
        <GameCard
          title="Flappy Bird"
          href="/games/flappy-bird"
          icon={<FlappyBirdIcon />}
          color="bg-[var(--color-turquoise)]"
          delay={100}
        />
        <GameCard
          title="Space Invaders"
          href="/games/space-invaders"
          icon={<SpaceInvadersIcon />}
          color="bg-[var(--color-purple)]"
          delay={150}
        />
        <GameCard
          title="Bubble Pop"
          href="/games/bubble-pop"
          icon={<BubblePopIcon />}
          color="bg-[var(--color-coral)]"
          delay={200}
        />
        <GameCard
          title="Memory Match"
          href="/games/animal-memory"
          icon={<AnimalMemoryIcon />}
          color="bg-[var(--color-orange)]"
          delay={250}
        />
        <GameCard
          title="Farm Sounds"
          href="/games/farm-sounds"
          icon={<FarmSoundsIcon />}
          color="bg-[var(--color-green)]"
          delay={300}
        />
        <GameCard
          title="Fruit Catch"
          href="/games/fruit-catch"
          icon={<FruitCatchIcon />}
          color="bg-[var(--color-sunny)]"
          delay={350}
        />
        <GameCard
          title="Shape Sorter"
          href="/games/shape-sorter"
          icon={<ShapeSorterIcon />}
          color="bg-[var(--color-pink)]"
          delay={400}
        />
        <GameCard
          title="Maze Runner"
          href="/games/maze-runner"
          icon={<MazeRunnerIcon />}
          color="bg-[var(--color-turquoise)]"
          delay={450}
        />
        <GameCard
          title="Coloring Book"
          href="/games/coloring-book"
          icon={<ColoringBookIcon />}
          color="bg-[var(--color-blue)]"
          delay={500}
        />
      </div>

      {/* Footer */}
      <p className="mt-8 sm:mt-12 text-gray-400 text-sm relative z-10">
        Built with love for little gamers... by Bert :)
      </p>
    </main>
  );
};

export default Home;
